<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('add') }} {{ $t('item-catalog') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense>
				<v-col cols="12">
					<v-text-field v-model="itemCatalog.name" :label="$t('name')" dense outlined hide-details />
				</v-col>
				<v-col cols="12">
					<v-text-field v-model="itemCatalog.manufacturer" :label="$t('manufacturer')" dense outlined hide-details />
				</v-col>
				<v-col cols="12">
					<v-text-field v-model="itemCatalog.modelNumber" :label="$t('model-number')" dense outlined hide-details />
				</v-col>
				<v-col cols="12">
					<v-select
						v-model="itemCatalog.category"
						:label="$t('category')"
						:items="categories"
						item-text="description"
						item-value="code"
						dense
						outlined
						hide-details
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="itemCatalog.defaultWarrantyMonths"
						:label="$t('warranty-length')"
						:suffix="$t('months')"
						dense
						outlined
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()"
						hide-details />
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="itemCatalog.defaultLifetimeMonths"
						:label="$t('lifetime-length')"
						:suffix="$t('months')"
						dense
						outlined
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()"
						hide-details />
				</v-col>
				<v-col cols="12">
					<v-textarea v-model="itemCatalog.notes" :label="$t('notes')" dense outlined hide-details no-resize />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="!canSave" @click="save">{{ $t('save') }}</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
	name: 'AddInventoryItemCatalog',
	data () {
		return {
			itemCatalog: {
				name: '',
				manufacturer: '',
				modelNumber: '',
				category: '',
				defaultWarrantyMonths: null,
				defaultLifetimeMonths: null,
				notes: '',
			},
			itemCatalogTemplate: {
				name: '',
				manufacturer: '',
				modelNumber: '',
				category: '',
				defaultWarrantyMonths: null,
				defaultLifetimeMonths: null,
				notes: '',
			},
		};
	},
	computed: {
		...mapState({
			categories: (state) => state.inventoryItemCatalogs.itemCategoryOptions,
		}),
		canSave () {
			return (
				this.itemCatalog.name.trim() &&
				this.itemCatalog.manufacturer.trim() &&
				this.itemCatalog.modelNumber.trim() &&
				this.itemCatalog.category.trim() &&
				Number(this.itemCatalog.defaultWarrantyMonths) > 0 &&
				Number(this.itemCatalog.defaultLifetimeMonths) > 0
			);
		},
	},
	async mounted () {
		this.itemCatalog = { ...this.itemCatalogTemplate };
		if (!this.categories?.length) {
			await this.getInventoryItemCategoryOptions();
		}
	},
	methods: {
		...mapActions({
			getInventoryItemCategoryOptions: 'inventoryItemCatalogs/getInventoryItemCategoryOptions',
			getItemCatalogs: 'inventoryItemCatalogs/getItemCatalogs',
			addItemCatalog: 'inventoryItemCatalogs/addItemCatalog',
		}),
		closeDrawer () {
			this.itemCatalog = { ...this.itemCatalogTemplate };
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
		async save () {
			this.itemCatalog.defaultLifetimeMonths = Number(this.itemCatalog.defaultLifetimeMonths);
			this.itemCatalog.defaultWarrantyMonths = Number(this.itemCatalog.defaultWarrantyMonths);
			await this.addItemCatalog(this.itemCatalog);
			await this.getItemCatalogs();
			this.closeDrawer();
		},
	},
};
</script>
